module.exports = __webpack_public_path__ + "static/media/bars_action_set.36001bf2.svg";